import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

import type { SimilarwebFieldsConfig } from "app/pages/sales-intelligence/common-components/export-table/types";

import { getAccountsSourceFieldsConfig, getScoringFieldsConfig } from "./accountsFields";
import { getRequesterFieldsConfig } from "./requesterFields";
import { getSubsidiaryFieldsConfig } from "./subsidiaryFields";

export const getContactsSourceFieldsConfig = (): SimilarwebFieldsConfig =>
    Object.seal({
        ["company_name"]: {
            name: "Company name",
            example: "ACME Corp",
            field: "company_name",
        },
        site: {
            name: "Website",
            example: "acme-labs.com",
            field: "site",
        },
        ["email"]: {
            name: "Email",
            example: "john.smith@acme-labs.com",
            field: "email",
        },
        ["first_name"]: {
            name: "First Name",
            example: "John",
            field: "first_name",
        },
        ["last_name"]: {
            name: "Last Name",
            example: "Smith",
            field: "last_name",
        },
        ["job_title"]: {
            name: "Title",
            example: "Sales Director, Europe",
            field: "job_title",
        },
        ["department"]: {
            name: "Department",
            example: "SALES, OVERSIGHT",
            field: "department",
        },
        ["seniority"]: {
            name: "Seniority",
            example: "Senior Leadership",
            field: "seniority",
        },
        ["role"]: {
            name: "Role",
            example: "Director",
            field: "role",
        },
        ["country"]: {
            name: "Country",
            example: "United States",
            field: "country",
        },
        ["country_code"]: {
            name: "Country Code",
            example: "US",
            field: "country_code",
        },
        ["direct_phone"]: {
            name: "Direct Phone",
            example: "16462222222",
            field: "direct_phone",
        },
        ["mobile_phone"]: {
            name: "Mobile Phone",
            example: "16461111111",
            field: "mobile_phone",
        },
        ["contact_linkedin_url"]: {
            name: "LinkedIn URL",
            example: "https://www.linkedin.com/in/john-smith",
            field: "contact_linkedin_url",
        },
        ["revealed_by"]: {
            name: "Revealed By",
            example: "Jane Doe",
            field: "revealed_by",
        },
        ["revealed_date"]: {
            name: "Revealed Date",
            example: "01/01/2022",
            field: "revealed_date",
        },
    });

export const getContactsFields = (integrationName: Integration): Readonly<SimilarwebFieldsConfig> => {
    if (integrationName === "salesforce" || integrationName === "dynamics") {
        return Object.seal({
            ...getContactsSourceFieldsConfig(),
            ...getScoringFieldsConfig(),
            ...getRequesterFieldsConfig(),
        });
    }

    return Object.seal({
        ...getContactsSourceFieldsConfig(),
        ...getAccountsSourceFieldsConfig(),
        ...getRequesterFieldsConfig(),
        ...getSubsidiaryFieldsConfig(),
    });
};
